import gameConfig from '../../../config/game';


export default class HitTest{

    constructor(){
    }


    check(self){
        const items = GAME_REF.obj.eggs.items;

        // 重なったエリアの大きさを保持するための変数
        let maxOverlap = -Infinity;
        let mostOverlappingObject = null;

        items.forEach(item => {
            if(item !== self){
                let overlapArea = this._calculateOverlapArea(self.container, item.container);
                
                // オブジェクトの面積を計算します
                const selfArea = self.container.getBounds().width * self.container.getBounds().height;
                const itemArea = item.container.getBounds().width * item.container.getBounds().height;

                // 重なっている部分が許容範囲以下であれば、重なっていないと判断します
                if(overlapArea / Math.min(selfArea, itemArea) > gameConfig.hitThreshold){
                    if(overlapArea > maxOverlap){
                        maxOverlap = overlapArea;
                        mostOverlappingObject = item;
                    }
                }
            }
        });

        if(mostOverlappingObject !== null){
            return mostOverlappingObject;
        }
        else{
            return null;
        }
    }

    _checkOverlap(spriteA, spriteB){
        const boundsA = spriteA.getBounds();
        const boundsB = spriteB.getBounds();
        return Phaser.Geom.Intersects.RectangleToRectangle(boundsA, boundsB);
    }

    // オブジェクトが重なっているエリアの大きさを計算する
    _calculateOverlapArea(spriteA, spriteB){
        const boundsA = spriteA.getBounds();
        const boundsB = spriteB.getBounds();
        const xOverlap = Math.max(0, Math.min(boundsA.right, boundsB.right) - Math.max(boundsA.left, boundsB.left));
        const yOverlap = Math.max(0, Math.min(boundsA.bottom, boundsB.bottom) - Math.max(boundsA.top, boundsB.top));
        return xOverlap * yOverlap;
    }
}